import { render, staticRenderFns } from "./TransportationBatch.vue?vue&type=template&id=1ac8a254&scoped=true"
import script from "./TransportationBatch.vue?vue&type=script&lang=js"
export * from "./TransportationBatch.vue?vue&type=script&lang=js"
import style0 from "./TransportationBatch.vue?vue&type=style&index=0&id=1ac8a254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac8a254",
  null
  
)

export default component.exports